import React from 'react';
import { Modal, StyleSheet, View } from 'react-native';

import { Box, BoxProps } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { DESKTOP_PAGE_MARGIN } from '@/utils/constants-platform-specific';

type DesktopModalProps = BoxProps & {
    visible: boolean;
    onClose: () => void;
};

export const DesktopModal = ({ visible, onClose, style, children, ...panelProps }: DesktopModalProps) => (
    <Modal visible={visible} transparent animationType="none" onRequestClose={onClose}>
        <View style={styles.scrim} onStartShouldSetResponder={() => true} onResponderRelease={onClose} />
        <View style={styles.container} pointerEvents="box-none">
            <Box
                maxWidth="100%"
                maxHeight="100%"
                overflow="hidden"
                borderWidth={1}
                borderColor={ds.colorToken.border.strong}
                backgroundColor={ds.colorToken.background.neutral.subtler}
                style={[styles.panelShadow, style]}
                {...panelProps}
            >
                {children}
            </Box>
        </View>
    </Modal>
);

const styles = StyleSheet.create({
    scrim: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: ds.colorValue.background.scrim,
    },
    container: {
        ...StyleSheet.absoluteFillObject,
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: DESKTOP_PAGE_MARGIN,
        paddingVertical: 40,
    },
    panelShadow: {
        boxShadow: '0px 32px 64px 0px rgba(0, 0, 0, 0.4)',
    },
});
